import React, { Component } from 'react';
import {c_markers as colors} from '../a-Graphic/Colors';
import {p_size_1, p_size_2, p_size_3, p_size_4} from '../a-Graphic/Layout';

import getMyMap, {createNamesLayer, createCommuneMassLayer, getLegend,
  createPlacesLayer, createCommunesNamesLayerEasy} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendPlace from '../b-LeafletMap/Legend/LegendPlace';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';


class Education extends React.Component {

  componentDidMount() {
    /* EDUCATION AREAS */
    var places = this.props.territory.places;

    var pre_school = places.filter((p) => ["pre school"].includes(p.type.toLowerCase()))
    var pre_school_coords = pre_school.map((a) => a.coords)
    var primary = places.filter((p) => ["primary school"].includes(p.type.toLowerCase()))
    var primary_coords = primary.map((a) => a.coords)
    var secondary = places.filter((p) => ["secondary school"].includes(p.type.toLowerCase()))
    var secondary_coords = secondary.map((a) => a.coords)
    var high_school = places.filter((p) => ["high school"].includes(p.type.toLowerCase()))
    var high_school_coords = high_school.map((a) => a.coords)

    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    var communes_masses = communes.map((c) => c.status.scholars_11_14 + c.status.scholars_15_17 + c.status.scholars_18 + c.status.scholars_2_5 + c.status.scholars_6_10);
    var communes_labels = communes.map((c) => c.name + " - " +
    (c.status.scholars_11_14 + c.status.scholars_15_17 + c.status.scholars_18 + c.status.scholars_2_5 + c.status.scholars_6_10).toLocaleString("fr-FR") + " élèves");

    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = createCommuneMassLayer(mymap, communes, communes_masses, communes_labels);
    createPlacesLayer(mymap, high_school_coords, p_size_4/2, colors[3]);
    createPlacesLayer(mymap, secondary_coords, p_size_3/2, colors[2]);
    createPlacesLayer(mymap, primary_coords, p_size_2/2, colors[1]);
    createPlacesLayer(mymap, pre_school_coords, p_size_1/2, colors[0]);
    createCommunesNamesLayerEasy(mymap, communes)
    //createNamesLayer(mymap, communes_coords, communes_names);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
    var communes = this.props.territory.communes;
    var c_population_scholars = communes.map((c) => c.status.scholars_11_14 + c.status.scholars_15_17 + c.status.scholars_18 + c.status.scholars_2_5 + c.status.scholars_6_10);

    var [colors_legend, intervals] = getLegend(c_population_scholars);
    return(
      <div className="row">
        <div className="col">
          <div className="row align-items-end">
            <div className="col-10">
              <div style={{height: "500px"}} id={this.props.id}></div>
            </div>
            <div className="col-2 pr-0 pl-0">
                 <LegendCommune label="(nombre d'élèves)"/>
                 <LegendValues intervals={intervals} colors={colors_legend}/>
                 <div className="mt-4 mb-4"></div>
                 <LegendPlace color={colors[0]} size={p_size_1+2} label="Ecole maternelle"/>
                 <LegendPlace color={colors[1]} size={p_size_2+2} label="Ecole primaire"/>
                 <LegendPlace color={colors[2]} size={p_size_3+2} label="Collège"/>
                 <LegendPlace color={colors[3]} size={p_size_4+2} label="Lycée"/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Education;
